<div class="layout-ParentDiv innerDiv">
  <div class="layout-dashboard addPage">
    <div class="p-grid">
      <div class="p-col-12 mainFormPadding">
        <div class="card ">
          <p-toast key="toastmsg" position="top-right"></p-toast>
          <form [formGroup]="discountCouponsForm" *ngIf="this.discountCouponsForm">
            <div class="p-fluid p-formgrid p-grid m-0">
              <div class="p-field p-col-12 div-border p-p-0">
                <h3 class="head-page-title">
                  {{pagetitle}}
                </h3>
              </div>
            </div>

            <div class="p-fluid p-formgrid p-grid">
              <div class="p-field p-col-12 p-fluid p-formgrid p-grid mainFormGap">
                <div class="p-field p-col-6 addFormDropDown">
                  <label for="module">Module <span class="mandatory-fields">*</span></label>
                  <p-dropdown inputId="module" [options]="couponsModules" formControlName="module"
                    placeholder="Select Module" optionLabel="name"
                    [ngClass]="{ 'is-invalid': submitted && f.module.errors }"></p-dropdown>
                  <div *ngIf="submitted && f.module.errors" class="invalid-feedback">
                    <div *ngIf="f.module.errors.required">Module is required</div>
                  </div>
                </div>
                <div class="p-field p-col-6">
                  <label for="name">Coupon Name <span class="mandatory-fields">*</span></label>
                  <input formControlName="name" type="text" pInputText class="form-control"
                    [ngClass]="{ 'is-invalid': submitted && f.name.errors }" placeholder="Enter coupon name">
                  <div *ngIf="submitted && f.name.errors" class="invalid-feedback">
                    <div *ngIf="f.name.errors.required">Coupon Name is required</div>
                  </div>
                </div>
                <div class="p-field p-col-6 addFormDropDown">
                  <label for="type">Discount Type <span class="mandatory-fields">*</span></label>
                  <p-dropdown inputId="type" [options]="couponDiscountTypes" formControlName="type"
                    placeholder="Select Discount Type" optionLabel="label" (onChange)="onSelectDiscountType($event)"
                    [ngClass]="{ 'is-invalid': submitted && f.type.errors }"></p-dropdown>
                  <div *ngIf="submitted && f.type.errors" class="invalid-feedback">
                    <div *ngIf="f.type.errors.required">Discount Type is required</div>
                  </div>
                </div>
                <div class="p-field p-col-6 numberform">
                  <label for="value">Discount Value <span class="mandatory-fields">*</span></label>
                  <p-inputNumber formControlName="value" [useGrouping]="false" placeholder="Enter discount value"
                    [ngClass]="{ 'is-invalid': submitted && f.value.errors }"></p-inputNumber>
                  <div *ngIf="submitted && f.value.errors" class="invalid-feedback">
                    <div *ngIf="f.value.errors.required">Discount Value is required</div>
                    <div *ngIf="((f.value.errors.min || f.value.errors.max) && discountType === 'percentage')">Discount
                      Value must be between 1 to 100</div>
                    <div *ngIf="(f.value.errors.min && discountType === 'flat')">Discount Value must be atleast 1</div>
                  </div>
                </div>
                <div class="p-field p-col-12">
                  <label for="description">Description <span class="mandatory-fields">*</span></label>
                  <textarea inputId="textarea" formControlName="description" rows="5" cols="30" class="form-control"
                    pInputTextarea [ngClass]="{ 'is-invalid': submitted && f.description.errors }"
                    placeholder="Describe the coupon here"></textarea>
                  <div *ngIf="submitted && f.description.errors" class="invalid-feedback">
                    <div *ngIf="f.description.errors.required">Description is required</div>
                  </div>
                </div>
                <div class="p-field p-col-12 formFlexDiv ">
                  <div class="p-field p-col-3 p-fluid p-formgrid p-grid mainFormGap m-0">
                    <label for="code">Code <span class="mandatory-fields">*</span></label>
                    <input formControlName="code" type="text" pInputText class="form-control"
                      [ngClass]="{ 'is-invalid': submitted && f.code.errors }" placeholder="Enter the coupon code">
                    <div *ngIf="submitted && f.code.errors" class="invalid-feedback">
                      <div *ngIf="f.code.errors.required">Coupon Code is required</div>
                    </div>
                  </div>
                     <div class="p-field p-col-3 addFormDropDown p-formgrid   mainFormGap m-0" *ngIf="!academyId">
                    <label for="academyId">Academy <span class="mandatory-fields">*</span></label>
                    <p-dropdown inputId="academyId" [options]="academiesList" formControlName="academyId"
                      placeholder="Select Academy" optionLabel="name" optionValue="id" [filter]="true"
                      [ngClass]="{ 'is-invalid': submitted && f.academyId.errors }"></p-dropdown>
                    <div *ngIf="submitted && f.academyId.errors" class="invalid-feedback">
                      <div *ngIf="f.academyId.errors.required">Please select Academy</div>
                    </div>
                  </div>
                 
                </div>
                  
                <div class="p-field p-col-12">
                  <label for="termsAndCondition">Terms & Conditions <span class="mandatory-fields">*</span></label>
                  <textarea inputId="textarea" formControlName="termsAndCondition" rows="5" cols="30"
                    class="form-control" pInputTextarea
                    [ngClass]="{ 'is-invalid': submitted && f.termsAndCondition.errors }"
                    placeholder="Enter terms & conditions (e.g. validity, usage limits, exclusions)"></textarea>
                  <div *ngIf="submitted && f.termsAndCondition.errors" class="invalid-feedback">
                    <div *ngIf="f.termsAndCondition.errors.required">Terms & Conditions is required</div>
                  </div>
                </div>
                <div class="p-field p-col-12">
                  <p-divider type="dashed"></p-divider>
                </div>
                <div class="p-field p-col-6 calederForm">
                  <label for="startDate">Start Date <span class="mandatory-fields">*</span></label>
                  <p-calendar formControlName="startDate" monthNavigator="true" yearNavigator="true"
                    placeholder="Select start date" yearRange="{{yearRange}}" dateFormat="dd-mm-yy" [showIcon]="true"
                    [ngClass]="{ 'is-invalid': submitted && f.startDate.errors }"></p-calendar>
                  <div *ngIf="submitted && f.startDate.errors" class="invalid-feedback">
                    <div *ngIf="f.startDate.errors.required">Start Date is required</div>
                  </div>
                </div>
                <div class="p-field p-col-6 calederForm">
                  <label for="endDate">End Date <span class="mandatory-fields">*</span></label>
                  <p-calendar formControlName="endDate" monthNavigator="true" yearNavigator="true"
                    placeholder="Select end date" yearRange="{{yearRange}}" dateFormat="dd-mm-yy" [showIcon]="true"
                    [ngClass]="{ 'is-invalid': submitted && f.endDate.errors }"></p-calendar>
                  <div *ngIf="submitted && f.endDate.errors" class="invalid-feedback">
                    <div *ngIf="f.endDate.errors.required">End Date is required</div>
                  </div>
                </div>
                <div class="p-field p-col-6 addFormDropDown">
                  <label for="usageId">Coupon Usage <span class="mandatory-fields">*</span></label>
                  <p-dropdown inputId="usageId" [options]="couponsUsage" formControlName="usageId"
                    placeholder="Select coupon usage" optionLabel="name" (onChange)="onSelectCouponUsage($event)"
                    [ngClass]="{ 'is-invalid': submitted && f.usageId.errors }"></p-dropdown>
                  <div *ngIf="submitted && f.usageId.errors" class="invalid-feedback">
                    <div *ngIf="f.usageId.errors.required">Coupon Usage is required</div>
                  </div>
                </div>
                <div class="p-field p-col-6">
                  <label for="noOfTimes">No. Of Times <span class="mandatory-fields">*</span></label>
                  <input formControlName="noOfTimes" type="text" pInputText class="form-control"
                    [ngClass]="{ 'is-invalid': submitted && f.noOfTimes.errors }" placeholder="Enter no. of times">
                  <div *ngIf="submitted && f.noOfTimes.errors" class="invalid-feedback">
                    <div *ngIf="f.noOfTimes.errors.required">No. Of Times is required</div>
                  </div>
                </div>
                <div class="p-field p-col-12" formArrayName="availability">
                  <label for="status">Availability </label>
                  <ul class="availabilityListDiv">
                    <li *ngFor="let availabilityForm of availabilityFormArray.controls; let i=index;"
                      [formGroupName]="i">
                      <div class="availabilityList">
                        <div class="checkradio">
                          <p-inputSwitch class="checkbox-mt-10" formControlName="active"
                            [ngClass]="{ 'is-invalid': submitted && h('availability',i).active.errors }"></p-inputSwitch>
                          <div class="lableTag">
                            {{ availabilityForm.value.day | uppercase }}
                          </div>
                        </div>
                        <div class="calnederDiv">
                          <div class="mainDivCalender calederForm">
                              <p-calendar appendTo="body" inputId="calendar" formControlName="from" [hourFormat]="12"
                              placeholder="From" [timeOnly]="true" [showTime]="true" [readonlyInput]="true" class="mx-2"
                              [ngClass]="{ 'is-invalid': submitted && h('availability',i).from.errors }"
                              (onSelect)="onSelectTime($event,'from',i)"></p-calendar>
                            <div *ngIf=" submitted && h('availability',i).from.errors" class="invalid-feedback">
                              <div *ngIf="h('availability',i).from.errors.startTimeValidator">Please Enter Start Time
                                less than End Time</div>
                            </div> 
                          </div>
                         
                          <div class="dividerIcon">
                            -
                          </div>
                            <div class="mainDivCalender calederForm">
                            <p-calendar appendTo="body" inputId="calendar" formControlName="to" [hourFormat]="12"
                              placeholder="To" [timeOnly]="true" [showTime]="true" [readonlyInput]="true"
                              [ngClass]="{ 'is-invalid': submitted && h('availability',i).to.errors }"
                              (onSelect)="onSelectTime($event,'to',i)"></p-calendar>
                            <div *ngIf=" submitted && h('availability',i).to.errors" class="invalid-feedback">
                              <div *ngIf="h('availability',i).to.errors.required">Please Enter End Time</div>
                              <div *ngIf="h('availability',i).to.errors.endTimeValidator">Please Enter End Time greater
                                than Start Time</div>
                            </div>
                          </div>
                        </div>

                      </div>
                    </li>
                  </ul>
                </div>
                <div class="p-field p-col-12" formArrayName="refund">
                  <h5 class="h5">Refund</h5>
                  <div class="p-field p-col-6 d-flex refundDiv" *ngFor="let refundForm of refundFormArray.controls; let i=index;"
                    [formGroupName]="i">
                    <div class="  p-col-3   p-formgrid p-grid mainFormGap">
                      <label for="hours">Hours <span class="mandatory-fields">*</span></label>
                      <p-dropdown inputId="hours" [options]="couponsRefundHours" formControlName="hours"
                        optionDisabled="inactive" placeholder="Select Hours" optionLabel="name" [filter]="true"
                        [disabled]="disableCouponHours[i]"
                        [ngClass]="{ 'is-invalid': submitted && h('refund',i).hours.errors }"
                        (onChange)="onSelectCouponHour($event)"></p-dropdown>
                      <div *ngIf="submitted && h('refund',i).hours.errors" class="invalid-feedback">
                        <div *ngIf="h('refund',i).hours.errors.required">Please select refund hours</div>
                      </div>
                    </div>
                    <div class="  numberform p-col-3   p-formgrid p-grid mainFormGap">
                      <label for="percentage">Refund % <span class="mandatory-fields">*</span></label>
                      <p-inputNumber formControlName="percentage" [useGrouping]="false" placeholder="Enter percentage"
                        [ngClass]="{ 'is-invalid': submitted && h('refund',i).percentage.errors }"></p-inputNumber>
                      <div *ngIf="submitted && h('refund',i).percentage.errors" class="invalid-feedback">
                        <div *ngIf="h('refund',i).percentage.errors.required">Please enter percentage</div>
                        <div *ngIf="(h('refund',i).percentage.errors.min || h('refund',i).percentage.errors.max)">
                          Percentage Value must be between 1 to 100
                        </div>
                      </div>
                    </div>
                    <div class=" p-col-3 p-formgrid p-grid mainFormGap">
                      <div class="p-formgrid p-grid actionBtn">
                        <button type="button" (click)="addRefund()" [disabled]="!isCouponHourSelected" *ngIf="i === 0"
                          pButton icon="pi pi-plus" class="AddBtn p-mr-3" ></button>
                      </div>
                      <div class="p-formgrid p-grid actionBtn ">
                        <button type="button" (click)="removeRefund(i)" *ngIf="i !== 0" pButton icon="pi pi-trash"
                          class="removeBtn p-mr-3"  ></button>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="p-field p-col-12">
                  <div class="lineborderHR">
                    <hr>
                  </div>
                </div>
              </div>
            </div>


            <div class="button-set p-col-12 d-flex p-fluid p-jc-md-end bottom-footer">
              <div class="p-formgrid p-grid">
                <p-toast></p-toast>
                <button type="text" (click)="onSubmit()" pButton icon="pi pi-check" label="Save"
                  class="p-button-success save-btn p-mr-3" style="width: auto"></button>
                <button type="text" (click)="backLink()" pButton icon="pi pi-times" label="Cancel"
                  class="p-button-danger cancel-btn" style="width: auto"></button>
              </div>
            </div>
          </form>
        </div>
        <div class="button-set back">
          <div class="p-fluid p-formgrid">
            <p-toast></p-toast>
          </div>
        </div>
      </div>
      <p-confirmDialog [style]="{width:'450px'}"></p-confirmDialog>
    </div>
  </div>
</div>